module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921022649_T.5bb72f4a.jpg";